import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { ApiService } from 'src/app/service/apiServices';
declare var jquery: any;
declare var $: any;
import Swal from 'sweetalert2';
import { Global } from '../../../global';
import { AuthService } from '../../../service/auth/auth.service'

@Component({
  selector: 'app-list-establishment',
  templateUrl: './list-establishment.component.html',
  styleUrls: ['./list-establishment.component.css']
})
export class ListEstablishmentComponent implements OnInit {

  estab: any = {};
  listEstabs: any = [];
  filtro: string = "";

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private alerts: NgxAlertsService,
    private router: Router,
    private global: Global,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.getListEstabs();
  }

  saveUser = (estab) => {
  }

  getListEstabs = () => {
    Swal.fire('Favor aguarde');
    Swal.showLoading();
    this.service.Get(`Estabelecimento`).then(res => {
      this.listEstabs = res;
      for (let item of this.listEstabs) {
        this.global.applyMask(item)
      }
      Swal.close()
    }).catch(res => {
      Swal.close()
      this.emitError(res)
    })
  }

  confirmationAtivarDesativar = (id, ativo) => {
    Swal.fire({
      title: 'Atenção',
      text: `Tem certeza que deseja ${ativo ? "ativar" : "desativar"} esse estabelecimento?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#dc3545'
    }).then(
      result => {
        if (result.isConfirmed) {
          Swal.fire('Favor aguarde');
          Swal.showLoading();
          this.service.AtivarDesativar(`Estabelecimento/${id}`, ativo).then((res) => {
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Sucesso!',
              html: 'Operação realizada com sucesso!'
            }).then(
              result => {
                if (result.isConfirmed) {
                  this.getListEstabs();
                }
              }
            );
          }).catch((err) => {
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              html: err.error.erros[0].messagem
            });
          })
        }
      }
    );
  }

  emitError = (error) => {
    if (typeof error == 'string'){
      Swal.fire('Erro', `${error}`, 'error');
      return
    }
    if (error.status == 401 || error.error.status == 401){
      Swal.close()
      this.authService.logoutUser()
    }
    if (error.status === 404) {
      Swal.fire('Atenção', `${error.error}`, 'warning');
      return
    }
    if (error.status) {
      Swal.fire({ icon: 'error', title: 'Erro', html: `${error.status} - ${error.error.erros[0].messagem}` })
      return
    }
    if (error.alert) {
      Swal.fire('Atenção', `${error.txt}`, 'warning');
      return
    }
  }

  emitAlert = () => {
    Swal.close()
    this.alerts.notifyError({
      body: `Erro`,
      title: 'Erro'
    });
  }

  filtroLista() {
    if (this.listEstabs.length === 0) {
      return this.listEstabs;
    }
    return this.listEstabs.filter(
      e => e.nome.toLocaleLowerCase().includes(this.filtro.toLocaleLowerCase()) ||
        e.cnes.includes(this.filtro) ||
        e.cnpj.replace(".", "").replace(".", "").replace("/", "").replace("-", "").includes(this.filtro.replace(".", "").replace(".", "").replace("/", "").replace("-", ""))
    );
  }

}
